﻿window.vaneck = window.vaneck || {};


// Before using EpiServer Forms make sure it is initialized using vaneck.epiforms.isInitialized()
window.vaneck.epiforms = (function($) {
  var obj = {};

  obj.isInitialized = function() {
    if (typeof epi == 'undefined' ||
      typeof epi.EPiServer == 'undefined' ||
      typeof epi.EPiServer.Forms == 'undefined') {
      return false;
    } else {
      return true;
    }
  };

  obj.getForms = function() {
    if (obj.isInitialized()) {
      return epi.EPiServer.Forms;
    } else {
      console.error('EPiServer Forms was not properly initialized.');
      return undefined;
    }
  };

  obj.$epiforms = function() {
    if (typeof $$epiforms !== 'undefined') {
      return $$epiforms;
    } else {
      return $;
    }
  };

  return obj;
})(jQuery);

(function ($) {
  var epiFormWrapper = $('div.js-epi-form-wrapper');
  var aspNetForm = $('form.js-aspnet-form');

  var epiFormId = epiFormWrapper.data('form-id');
  var epiFormValidationCssClass = epiFormWrapper.data('validation-css-class');
  var epiFormFMetadata = epiFormWrapper.data('f-metadata');

  if (epiFormId) {
    aspNetForm.attr('id', epiFormId);
  }

  if (epiFormValidationCssClass) {
    aspNetForm.addClass(epiFormValidationCssClass);
  }

  if (epiFormFMetadata) {
    aspNetForm.data('f-metadata', epiFormFMetadata);
  }

  $(document).ready(function () {
      $("input[value='marketo-cookie-id']").each(function ($index, $input) {
          $input.value = GetMarketoId();
      });
  });
})(jQuery);